import React, {useEffect, useContext} from "react";
import { Row, Col, Button } from "react-bootstrap";
import BackButton from "./BackButton";
import NextButton from "./NextButton";
import SkipButton from "./SkipButton";
import getNextPage from "./getNextPage";
import {RouterContext} from "./Onboarding"

export default function ServiceAgreementsIntro(props) {
  const route = useContext(RouterContext)

  const nextPage = getNextPage(props.onboarding_progress);

  useEffect(() => {
    window.localStorage.setItem(
      "routerHistory",
      JSON.stringify([...route.get])
    );
  }, [route.get]);
  props.pageLocator();
  let chat = require("images/onboarding/chaticon.png");
  chat = <img className="pt-2" src={`/datapulse${chat}`} />;

  return (
    <>
      <Row className="mb-3 pb-3 justify-content-center">
        <Col md={7}>
          <div>
            <p className="pb-3 f28 visby-bold primary text-center">Next Up: Service Agreements</p>
          </div>
          <div>
            <p className=" f14 nunito-regular primary ">
              Congrats on making it through the basic setup and access! The client can take a deep breath, they are done for now! <br></br>
              <br></br> On the next two pages, we need to configure the service agreements for the services and sub-services that you selected in the beginning.
              We will set up the agreement information, and also create the makeup of the company's marketing team by providing leads, support, and points of
              contact for each specific service. We have already enabled/disabled services for you based on your answers from earlier, but if you need to make
              changes to the services being provided you can do so here as well.
            </p>
          </div>
        </Col>
      </Row>
      <input hidden name="current_onboarding_page" value={window.location.href} readOnly />
      <Row className=" pb-3 text-center justify-content-center mb-5">
        <Col md={7}>
          <Row className="justify-content-center">
            <Col md={2} className="service-agreement-chat-bubble">{chat}</Col>
            <Col className="text-left">
              <p className="f14 primary">
                <strong>
                  The remainder of onboarding for this account is to be completed by the team member only. If you are still on the onboarding meeting or call,
                  this section can be completed after that has been concluded.
                </strong>
              </p>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col>
          <div className="navButtonRow">
            <BackButton smaller />
            <NextButton
              validated={true} 
              btnText={`Let's go`}
              nextPage={nextPage.url}
              invalidText={`We need more information on this page before you continue.`}
              submitForm={props.submitForm}
              className="goBtn"
            />
          </div>
        </Col>
      </Row>
    </>
  );
}
